let sceneDepth = 0;
let sceneGuardEnabled = false;

export function enableSceneGuard(): void {
  sceneGuardEnabled = true;
}

export function isSceneGuardEnabled(): boolean {
  return sceneGuardEnabled;
}

export function isInsideExecuteScene(): boolean {
  return sceneDepth > 0;
}

export function enterExecuteScene(): void {
  sceneDepth++;
}

export function leaveExecuteScene(): void {
  sceneDepth--;
}

export function assertDrawContext(): void {
  if (sceneGuardEnabled && sceneDepth === 0) {
    throw new Error('Draw call outside executeScene()');
  }
}
